import { useCallback, useEffect, useRef } from "react";

export const useDebounceCallback = (fn: Function, delay: number) => {
    const timeoutRef = useRef<number>();
  
    const clearTimer = useCallback(() => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    }, []);
  
    useEffect(() => clearTimer, []);
  
    const cb = useCallback(
      (...args: any[]) => {
        clearTimer();
        //@ts-ignore
        timeoutRef.current = setTimeout(() => fn(...args), delay);
      },
      [fn, delay]
    );
  
    return cb;
  };import { useCallback, useEffect, useRef } from "react";

export const useDebounceCallback = (fn: Function, delay: number) => {
    const timeoutRef = useRef<number>();
  
    const clearTimer = useCallback(() => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    }, []);
  
    useEffect(() => clearTimer, []);
  
    const cb = useCallback(
      (...args: any[]) => {
        clearTimer();
        //@ts-ignore
        timeoutRef.current = setTimeout(() => fn(...args), delay);
      },
      [fn, delay]
    );
  
    return cb;
  };